import PropTypes from 'prop-types';
import styles from './UploadArea.module.css';
import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CircularProgress } from '@mui/material';

export function UploadArea({ onUpload, acceptedTypes, text }) {
    const [isUploading, setIsUploading] = useState(false);

    const onDrop = useCallback(async (acceptedFiles) => {
        try {
            setIsUploading(true);
            await onUpload?.(acceptedFiles);
        } catch (error) {
            console.error('Error uploading files:', error);
        } finally {
            setIsUploading(false);
        }
    }, [onUpload]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: acceptedTypes,
        multiple: true,
    });
    const { ref, ...rootProps } = getRootProps();

    const dropAreaText = text ?? 'Drag \'n\' drop some PDF files here, or click to select files';

    return (
        <div className={styles.uploadArea} {...rootProps}>
            {isUploading ? (
                <CircularProgress />
            ) : (
                <>
                    <CloudUploadIcon fontSize="large" color="primary" />
                    <input {...getInputProps()} />
                    {
                        isDragActive
                            ? (<p>Drop the files here...</p>)
                            : (<p>{ dropAreaText }</p>)
                    }
                </>
            )}
        </div>
    );
}

UploadArea.propTypes = {
    onUpload: PropTypes.func,
    acceptedTypes: PropTypes.object
};
